/* Create action types */
import createActionTypes from '../createActionTypes';

export const GET_CAMPAIGN = createActionTypes('GET_CAMPAIGN');
export const GET_CAMPAIGN_REPORT = createActionTypes('GET_CAMPAIGN_REPORT');
export const GET_CAMPAIGN_FINANCIAL_METRICS = createActionTypes('GET_CAMPAIGN_FINANCIAL_METRICS');
export const GET_CAMPAIGN_FEED = createActionTypes('GET_CAMPAIGN_FEED');
